import { initParallax } from "./modules/_parallax.js";
import { initMenu } from "./modules/_menu.js";
import { initAnimations } from "./modules/_animations.js";
import { deobfuscateEmails } from "./modules/_deobfuscate.js";
import "../../_vendor/node_modules/leaflet/dist/leaflet.js";

// Remove no-js class
document.querySelector(".no-js").classList.remove("no-js");

// Initialize modules
initParallax();
initMenu();
initAnimations();
deobfuscateEmails();
